var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6BE00",
    stroke: "#F6BE00",
    strokeWidth: 1.5,
    d: "M5.79 16.928L2.02 18.29l1.21-3.518a8.486 8.486 0 1 1 2.559 2.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M15.166 12.093c-.068-.114-.249-.182-.52-.319-.271-.136-1.604-.797-1.852-.888-.248-.09-.43-.136-.61.137s-.7.888-.858 1.07c-.159.182-.316.205-.588.068-.27-.136-1.144-.424-2.18-1.354-.805-.723-1.349-1.616-1.507-1.89-.158-.273-.017-.42.119-.556.122-.123.271-.32.406-.478.136-.16.181-.273.271-.456.091-.182.046-.341-.022-.478-.068-.136-.61-1.48-.836-2.026-.226-.546-.451-.455-.61-.455-.158 0-.339-.023-.52-.023a.994.994 0 0 0-.722.341c-.249.274-.949.934-.949 2.277s.971 2.64 1.107 2.822c.135.182 1.875 3.028 4.63 4.12 2.756 1.093 2.756.728 3.253.683.496-.046 1.603-.66 1.83-1.297.225-.638.225-1.185.158-1.298z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.ccbaaa6b8a1b158b882abafb29ce4386.svg";
export { ForwardRef as ReactComponent };